import { FC, useCallback } from 'react';
import { LocalAccount } from '../../../types/LocalAccount';
import { Button, ButtonSizes, ButtonStyles, Icons } from '@silverfort/sf-components';
import { useLocalAccounts } from '../../../context/LocalAccountsContext';
import { useAppDrawer } from '../../../../AppDrawer/AppDrawerProvider';
import LocalAccountDrawer from './LocalAccountDrawer/LocalAccountDrawer';
import { PopupProvider } from '../../../context/PopupProvider';
import { isAccountMatchingEnabled } from '../../../utils';
import { useSnackAlert } from '../../../context/SnackAlertProvider';

type Props = LocalAccount;

// TODO: Remove this once we have project-level snack alert and popup providers
const DrawerProviders: FC = ({ children }) => {
    return <PopupProvider>{children}</PopupProvider>;
};

const ManageCell: FC<Props> = (localAccount) => {
    const { mutate: mutateLocalAccounts, userSession, systemData } = useLocalAccounts();
    const { openSnackAlert, closeSnackAlert } = useSnackAlert();
    const { displayContent, closeAppDrawer } = useAppDrawer();
    const hasAccountMatching = isAccountMatchingEnabled(systemData);

    const handleUpdateFromDrawer = useCallback(() => {
        mutateLocalAccounts();
        closeAppDrawer();
    }, [mutateLocalAccounts, closeAppDrawer]);

    const handleClick = useCallback(() => {
        if (!userSession) return;

        displayContent(
            <DrawerProviders>
                <LocalAccountDrawer
                    localAccount={localAccount}
                    userSession={userSession}
                    onAccountUpdated={handleUpdateFromDrawer}
                    hasAccountMatching={hasAccountMatching}
                    snackAlertContext={{ openSnackAlert, closeSnackAlert }}
                />
            </DrawerProviders>
        );
    }, [
        userSession,
        displayContent,
        localAccount,
        handleUpdateFromDrawer,
        hasAccountMatching,
        openSnackAlert,
        closeSnackAlert
    ]);

    return (
        <div className="flex justify-end">
            <Button
                className="opacity-0 group-hover:opacity-100"
                iconRight={Icons.Settings}
                onClick={handleClick}
                buttonStyle={ButtonStyles.GhostSolid}
                buttonSize={ButtonSizes.Small}
            />
        </div>
    );
};

export default ManageCell;
